export default {"src":"/_next/static/media/logo-5.54496ba4.svg","height":49,"width":47,"blurWidth":0,"blurHeight":0};